export class UtilsService {
  static isNotUndefinedOrNull(value: any) {
    return value !== undefined && value !== null;
  }
}
